import L from 'leaflet';
import { IMapMarkerIcon } from './layers';

export const mapMarkerToLeafletIcon = (icon: IMapMarkerIcon): L.Icon => {
    return L.icon({
        iconUrl: icon.iconUrl,
        shadowUrl: undefined,
        iconSize: icon.iconSize, // size of the icon
        iconAnchor: icon.iconAnchor, // point of the icon which will correspond to marker's location
        tooltipAnchor: icon.tooltipAnchor // point from which the tooltip should open relative to the iconAnchor
      });
}